export const TOKEN_KEY = 'login_access_token'
export const LOGIN_ACCESS_USER_ID = 'login_access_user_id'

// 在当前产品页上方打开登录弹窗
export const openLoginModal = () => {
  window.dispatchEvent(new CustomEvent('openLoginModal'))
}

// url 编码 >> /编码为 %2F，?编码为：%3F，=编码为：%3D
// 判断是否存在 “/cms” 或 “%2Fcms” 或 “cms?” 或 “cms%3F” 或 以 “cms 结尾”
export const CMS_ROUTE_REGEXP = /(\/|%2F)cms(\/|%2F|\?|%3F|$)/i
// 截取租户ID（19位雪花） >> /cms?tid=7217097077380087808
export const MATCH_TID_REGEXP = /(\/|%2F)cms(\/|%2F|\?|%3F|$).*tid(=|%3D)(\d{19})/i
